import dayjs, { ManipulateType } from 'dayjs';
import { NewsFrequency } from 'src/app/view/news/service/models/news-frequency';

export class NotificationHelper {
  /**
   * Get news notifications dates for repetitive notifications
   * @param {number}        startDate
   * @param {number}        endDate
   * @param {NewsFrequency} frequency
   * @return {Date[]} list of dates to send notification
   */
  public static getNewsReminderNotificationDates(startDate: number, endDate: number, frequency: NewsFrequency): Date[] {
    const dates: Date[] = [];
    const from = dayjs(startDate);
    from.set('hours', Math.max(from.hour(), 8));

    const to = dayjs(endDate);
    let increment = 1;
    let unit: ManipulateType = 'month';

    switch (frequency) {
      case NewsFrequency.EVERY_WEEK:
        unit = 'week';
        break;
      case NewsFrequency.EVERY_QUARTER:
        increment = 3;
        break;
      case NewsFrequency.EVERY_YEAR:
        unit = 'year';
        break;
    }

    for (let date = from; date.isBefore(to); date = date.add(increment, unit)) {
      // ? don't save first date and save only future dates to omit multiple notifications in short time
      if (date != from || date.isAfter(dayjs(Date.now()))) dates.push(date.toDate());
    }

    return dates;
  }

  /**
   * Check send time; If time is today after 8:00AM - don't change, else - set at that date on 8:00 AM
   * @param {Date | number} dateFrom
   * @return {Date} news notification send time
   */
  public static getNewsSendTime(dateFrom: Date | number): Date {
    //* Notification date and time set-up
    const todaysDateNotificationTime = dayjs().set('hour', 8).set('minute', 0).set('second', 0); // send notification at 8:00

    let notificationDate = dayjs(dateFrom).set('hour', 8).set('minute', 0).set('second', 0);

    // ? if news dateFrom is before TODAY, set notification time to TODAY 8:00AM
    if (todaysDateNotificationTime.isAfter(notificationDate)) {
      notificationDate = todaysDateNotificationTime;
    }

    const currentTime = dayjs().set('second', 0);
    if (currentTime.isAfter(todaysDateNotificationTime) && notificationDate.isSame(currentTime, 'day')) {
      // ! if notification is for TODAY, and it's after 8:00, send notification right away (+/- 5 minutes, to match notification
      // queue)
      const minutes = currentTime.minute() % 5;
      notificationDate = currentTime.add(5 - minutes, 'minute');
    }
    return notificationDate.toDate();
  }
}
